// Autogenerated file
export const tileTypesEnum = {
    DoubleGis: "DoubleGis",
    Osm: "Osm",
    DoubleGisPaid: "DoubleGisPaid",
};
export const tileTypes = [
    { label: "2GIS", value: "DoubleGis" },
    { label: "OSM", value: "Osm" },
    { label: "2GIS (платный)", value: "DoubleGisPaid" },
];
